<template>
  <v-app light>
    <v-content>
      <section>
        <v-parallax src="/fond_mini.jpg" height="400">
          <v-layout column align-center justify-center class="white--text">
            <img
              :src="require('./assets/logo_skydev_light.png')"
              alt="SkyDev"
              contain
              height="130"
            />
            <h1 class="white--text mb-2 display-1 text-center">
              La technologie qui vous simplifie la vie
            </h1>
            <div class="subheading mb-4 text-center">
              SkyDev est spécialisée dans le développement d'applications
              mobiles, web &amp; intranets sur mesure et adaptés à vos besoins
            </div>
          </v-layout>
        </v-parallax>
      </section>

      <section>
        <v-layout column wrap class="my-12" align-center>
          <v-flex xs12 sm4 class="my-4">
            <div class="text-center">
              <h2 class="headline">Notre savoir-faire</h2>
            </div>
          </v-flex>
          <v-flex xs12>
            <v-container grid-list-xl>
              <v-layout row wrap align-center>
                <v-flex xs12 sm4 md4>
                  <v-card flat class="transparent">
                    <v-card-text class="text-center">
                      <v-icon x-large class="blue--text text--lighten-2"
                        >mdi-cellphone</v-icon
                      >
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-center">Application mobile</div>
                    </v-card-title>
                    <v-card-text class="text-center"
                      >iOS et Android sont nos terrains de jeu</v-card-text
                    >
                  </v-card>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-card flat class="transparent">
                    <v-card-text class="text-center">
                      <v-icon x-large class="blue--text text--lighten-2"
                        >mdi-desktop-mac</v-icon
                      >
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline">Application web</div>
                    </v-card-title>
                    <v-card-text class="text-center"
                      >Pour mieux gérer votre activité</v-card-text
                    >
                  </v-card>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-card flat class="transparent">
                    <v-card-text class="text-center">
                      <v-icon x-large class="blue--text text--lighten-2"
                        >mdi-cloud</v-icon
                      >
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-center">Hébergement</div>
                    </v-card-title>
                    <v-card-text class="text-center"
                      >Nous assurons la mise en ligne et la disponiblité de
                      votre site</v-card-text
                    >
                  </v-card>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-card flat class="transparent">
                    <v-card-text class="text-center">
                      <v-icon x-large class="blue--text text--lighten-2"
                        >mdi-finance</v-icon
                      >
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-center">
                        Audit &amp; Conseils
                      </div>
                    </v-card-title>
                    <v-card-text class="text-center">
                      Plus de 8 ans d'expérience
                      <br />à votre service
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm4 md4 class="offset-sm-4 offset-md-4">
                  <v-card flat class="transparent">
                    <v-card-text class="text-center">
                      <v-icon x-large class="blue--text text--lighten-2"
                        >mdi-account-group</v-icon
                      >
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-center">Formation</div>
                    </v-card-title>
                    <v-card-text class="text-center">
                      Entre 1 et 10 personnes
                      <br />pendant 1 à 5 jours
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </section>

      <v-divider></v-divider>

      <section>
        <v-container grid-list-xl>
          <v-layout row wrap justify-center class="my-12">
            <v-flex xs12 sm4>
              <v-card flat class="transparent">
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline">À propos</div>
                </v-card-title>
                <v-card-text>
                  Fondé en septembre 2013 par
                  <a href="https://yannicklorenz.fr" target="_blank"
                    >Yannick Lorenz</a
                  >, SkyDev est depuis au service de TPE/ PME / startup désirant
                  augmenter leur productivité.
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm4 offset-sm1>
              <v-card flat class="transparent">
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline">Contact</div>
                </v-card-title>

                <v-list class="transparent">
                  <v-list-item>
                    <v-list-item-action>
                      <v-icon class="blue--text text--lighten-2"
                        >mdi-phone</v-icon
                      >
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title
                        v-if="!isQuestionPhoneVisible && !isPhoneVisible"
                        @click="displayQuestionPhone()"
                        class="no_overflow"
                        >Voir le téléphone {{ tmp_p }}</v-list-item-title
                      >
                      <v-list-item-title
                        v-if="isQuestionPhoneVisible && !isPhoneVisible"
                        class="no_overflow"
                      >
                        <v-text-field
                          ref="input_phone"
                          label="4 + 5 = ?"
                          v-model="phone_answer"
                        ></v-text-field>
                      </v-list-item-title>
                      <v-list-item-title
                        v-if="isPhoneVisible"
                        class="no_overflow"
                      >
                        <a :href="`tel:${tmp_p}`">{{ tmp_p }}</a>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-action>
                      <v-icon class="blue--text text--lighten-2"
                        >mdi-map-marker</v-icon
                      >
                    </v-list-item-action>

                    <v-list-item-title class="no_overflow"
                      >Strasbourg, France</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-action>
                      <v-icon class="blue--text text--lighten-2"
                        >mdi-email</v-icon
                      >
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title
                        v-if="!isQuestionMailVisible && !isMailVisible"
                        @click="displayQuestionMail()"
                        class="no_overflow"
                        >Voir l'email {{ tmp_m }}</v-list-item-title
                      >
                      <v-list-item-title
                        v-if="isQuestionMailVisible && !isMailVisible"
                        class="no_overflow"
                      >
                        <v-text-field
                          ref="input_mail"
                          label="3 + 2 = ?"
                          v-model="mail_answer"
                        ></v-text-field>
                      </v-list-item-title>
                      <v-list-item-title class="no_overflow">
                        <a :href="`mailto:${tmp_m}`">{{ tmp_m }}</a>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </section>

      <v-footer color="blue darken-2">
        <v-layout row wrap align-center>
          <v-flex xs12>
            <div class="text-center white--text ml-4">
              Made with
              <v-icon class="red--text">mdi-heart</v-icon>&nbsp;by
              <a
                class="white--text"
                href="https://vuetifyjs.com"
                target="_blank"
                >Vuetify</a
              >
              and
              <a class="white--text" href="https://yannicklorenz.fr"
                >Lorenz Yannick</a
              >
              - 2022
            </div>
          </v-flex>
        </v-layout>
      </v-footer>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    isQuestionPhoneVisible: false,
    isPhoneVisible: false,
    phone_answer: null,
    tmp_p: "",
    isQuestionMailVisible: false,
    isMailVisible: false,
    mail_answer: null,
    tmp_m: "",
  }),

  methods: {
    displayQuestionPhone: function () {
      var self = this;
      self.isQuestionPhoneVisible = true;
      setTimeout(function () {
        self.$refs.input_phone.focus();
      }, 300);
    },
    displayPhone: function () {
      var self = this;
      self.isPhoneVisible = true;

      self.tmp_p = "+33 9 09 58 62 56".replace(/9/gi, "6");
    },
    displayQuestionMail: function () {
      var self = this;
      self.isQuestionMailVisible = true;
      setTimeout(function () {
        self.$refs.input_mail.focus();
      }, 300);
    },
    displayMail: function () {
      var self = this;
      self.isMailVisible = true;
      self.tmp_m = "9lorenz@sk9dev.fr".replace(/9/gi, "y");
    },
  },
  watch: {
    phone_answer: function (value) {
      console.log("phone_answer : " + value);
      var self = this;
      if (value === "9") {
        self.isQuestionPhoneVisible = false;

        self.displayPhone();
      }
    },
    mail_answer: function (value) {
      console.log("mail_answer : " + value);
      var self = this;
      if (value === "5") {
        self.isQuestionMailVisible = false;

        self.displayMail();
      }
    },
  },
};
</script>



<style scoped>
.no_overflow {
  overflow: hidden;
  text-overflow: clip;
  white-space: normal;
}
</style>